import src from "IMAGE";
export default { src, width: 351, height: 209, blurWidth: 0, blurHeight: 0};
